const getters = {
  userInfo: (state) => state.userManage.userInfo,
  applicableObject: (state) => state.dataManage.applicableObject,
  courseSelect: (state) => state.dataManage.courseSelect,
  courseSelectObj: (state) => state.dataManage.courseSelectObj,
  classTypeData: (state) => state.dataManage.classTypeData,
  statisticsStatus: (state) => state.dataManage.statisticsStatus,
  currentAcademicYear: (state) => state.dataManage.currentAcademicYear,
  currentSemerter: (state) => state.dataManage.currentSemerter,
  userId: (state) => state.userManage.userInfo.id,
  userSubjects: (state) =>
    (state.userManage.userInfo.userSubjects || [])
      .map((item) => Number(item.subjectType))
      .sort((a, b) => a - b),
  roleList: (state) => state.userManage.userInfo.permissions || [],
  routerList: (state) => state.routerManage.routerList,
  categoryRouterList: (state) => state.routerManage.categoryRouterList,
  sidebarRouterList: (state) => state.routerManage.sidebarRouterList,
  handleRightsList: (state) => state.routerManage.handleRightsList,
  secondRouter: (state) => state.routerManage.secondRouter,
  indexRouter: (state) => state.routerManage.indexRouter,
  handleType: (state) => state.loginManage.handleType,
  systemName: (state) => state.dataManage.systemName,
  localeLanguage: (state) => state.dataManage.localeLanguage,
  pageSize: (state) => state.dataManage.pageSize,
  formatDate: (state) => state.dataManage.formatDate,
  formatTime: (state) => state.dataManage.formatTime,
  yearList: (state) => state.dataManage.yearList,
  enrollmentYearList: (state) => state.dataManage.enrollmentYearList,
  academicYearList: (state) => state.dataManage.academicYearList,
  classStatusList: (state) => state.dataManage.classStatusList,
  classTypeList: (state) => state.dataManage.classTypeList,
  examList: (state) => state.dataManage.examList,
  gradeList: (state) => state.dataManage.gradeList,
  currentGradeList: (state) => state.dataManage.currentGradeList,
  semesterList: (state) => state.dataManage.semesterList,
  genderList: (state) => state.dataManage.genderList,
  detailName: (state) => state.routerManage.detailName,
  studentMajorOption: (state) => state.dataManage.studentMajorOption,
}

export default getters
